import wixData from 'wix-data';

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function july1onImage_click(event) {
$w("#july1onImage").show();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").show();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july2onImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").show();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").show();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july3onImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").show();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").show();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july4onImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").show();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").show();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july5onImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").show();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").show();
$w("#july6Box").hide();
}

export function july6onImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").show();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").show();
}

export function july1offImage_click(event) {
$w("#july1onImage").show();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").show();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july2offImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").show();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").show();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july3offImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").show();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").show();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july4offImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").show();
$w("#july5onImage").hide();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").show();
$w("#july5Box").hide();
$w("#july6Box").hide();
}

export function july5offImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").show();
$w("#july6onImage").hide();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").show();
$w("#july6Box").hide();
}

export function july6offImage_click(event) {
$w("#july1onImage").hide();
$w("#july2onImage").hide();
$w("#july3onImage").hide();
$w("#july4onImage").hide();
$w("#july5onImage").hide();
$w("#july6onImage").show();
$w("#july1Box").hide();
$w("#july2Box").hide();
$w("#july3Box").hide();
$w("#july4Box").hide();
$w("#july5Box").hide();
$w("#july6Box").show();
}

export function july1offText_click(event) {
	//Add your code for this event here: 
}